import 'datatables.net';
import $ from 'jquery';
import React, {memo, useEffect, useState} from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
//import NewProjectViewComponent from '../../Components/Projekte/NewProjectViewComponent';
import '../../Styles/Aufmas.css';
import Select from "react-select";
import {CSVLink} from "react-csv";
import moment from "moment";
import {getOut, getToken} from "../../Utils/Common";


let listofProjects = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/readprojects", {
    method: 'POST', headers: {
        'Content-type': 'application/json',
    }, body: JSON.stringify({"token": getToken(), "data": {"organisationID": sessionStorage.getItem("org")}}),
})
    .then((response) => response.json())
    .catch((error) => {
        console.error('Error:', error);
    })

let options = []

if (listofProjects.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
    getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
} else {
    options = listofProjects.data.map(a => ({"label": a.projectName, "value": a.projectID}));

}


function AufmasComponent() {

    const [aufmassTableBody, setAufmassTableBody] = useState(<></>);
    const [projectInformation, setProjectInformation] = useState(false);

    const [oneDayDate, setOneDayDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [oneDayTickStatus, setOneDayTickStatus] = useState(false)

    const [aufmassapiresult, setaufmassapiresult] = useState([])
    const [dataforcsv, setdataforcsv] = useState([])

    const addWidth555 = {
        width: 150
    };

    function isCsvDataAvailabe() {
        return dataforcsv.length !== 0
    }

    function isValid() {
        return isProjectAvailable() && ((oneDayDate !== '') && (endDate !== '' || oneDayTickStatus))
    }

    function isProjectAvailable() {
        return projectInformation
    }

    function isOneDayDateActive() {
        return isProjectAvailable()
    }

    function isTwoDayDateActive() {
        return (!oneDayTickStatus) && isProjectAvailable()
    }

    async function getaufmasstabledata(apiBody) {

        return await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/getaufmasstabledata", {

            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify({"token": getToken(),"data":apiBody}),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
    }

    function fillTable(result) {
        const aufmassTableBodyData = result.map(({
                                                     id, position, kurzText, einheit, menge,teilmas
                                                 }) => <tr key={id}>
            <td>{position}</td>
            <td>{kurzText}</td>
            <td>{einheit}</td>
            <td>{menge}</td>
            <td>{teilmas}</td>
        </tr>);
        setAufmassTableBody(aufmassTableBodyData);

        $('#aufmassTable').DataTable({
            dom: 'frtilp', language: {
                fontcolor: 'white', url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
            }, oLanguage: {
                sSearch: '', searchPlaceholder: 'Suchen'
            }, order: [[1, 'asc']]
        });
        result.forEach(i => {
            delete i["id"]
        })
        setdataforcsv(result)
    }


    useEffect(async () => {
        console.log(aufmassapiresult)

    }, []);

    return (<>
            <br/> <br/>
            <div className='container handwai-dark'>
                <Row>
                    <Col md={6}>
                        <Form.Label className={"aufmasText"}>
                            Projekt auswählen: <span className="errorStyle">*</span>
                        </Form.Label>
                        <Select
                            options={options}
                            value={projectInformation}
                            placeholder="..."
                            onChange={(e) => {
                                setProjectInformation(e)

                            }}

                        />
                    </Col>;
                </Row>
                <br/>
                <br/>
                <Form id="upload-lv">
                    <Row>
                        <Col md={1}>

                            <td><input
                                disabled={!isProjectAvailable()}
                                onChange={event => {
                                    setOneDayTickStatus(event.target.checked)
                                    if (event.target.checked) {
                                        setEndDate('')
                                    }
                                }}
                                className="userdetailscheckbox"
                                type="checkbox"
                                id="checkbox"
                                defaultChecked={oneDayTickStatus}
                            /></td>
                        </Col>
                        <Col md={1}>
                            <Form.Label className={"aufmasText"}>
                                1 Tag
                            </Form.Label>
                        </Col>

                        <Col md={2}>

                            <Form.Group controlId="formGroupSingleDate">


                                <Form.Control
                                    disabled={!isOneDayDateActive()}
                                    type="date"
                                    className="handwai-input"
                                    style={addWidth555}
                                    onChange={(event) => {
                                        let eventValue = event.target.value;
                                        let date = moment(eventValue).format("DD-MM-YYYY")
                                        setOneDayDate(date);
                                    }}
                                />
                            </Form.Group>
                        </Col>



                        <Col md={2}>
                            {!oneDayTickStatus && <Form.Group controlId="formGroupEndDate">
                                <Form.Control
                                    disabled={!isTwoDayDateActive()}
                                    type="date"
                                    className="handwai-input"
                                    style={addWidth555}
                                    onChange={(event) => {
                                        let eventValue = event.target.value;
                                        let date = moment(eventValue).format("DD-MM-YYYY")
                                        setEndDate(date);
                                    }}
                                />
                            </Form.Group>}
                        </Col>;

                        <Col md={2}>
                            <Button
                                disabled={!isValid()}
                                //onClick={handleClick}
                                onClick={async () => {
                                    let apiBody = {
                                        projectInformation: projectInformation.value,
                                        startDate: oneDayDate,
                                        endDate: endDate
                                    }
                                    let result = await getaufmasstabledata(apiBody)
                                    setaufmassapiresult(result.data)
                                    fillTable(result.data)
                                    //prepareAufmassTableBody(aufmassapiresult)
                                }}
                                className="handwai-btn-create"
                                variant="success"
                                style={addWidth555}

                                //size="lg"
                                //block
                            >
                                Anzeigen
                            </Button>
                        </Col>

                    </Row>

                </Form>

                <br/>
                <br/>

                <table id='aufmassTable'
                       className='table'>
                    <thead>
                    <tr>
                        <th data-sortable='true' data-searchable='true'>
                            Position
                        </th>
                        <th data-sortable='true' data-searchable='true'>
                            Bezeichnung
                        </th>
                        <th data-sortable='true' data-searchable='true'>
                            Einheit
                        </th>
                        <th data-sortable='true' data-searchable='true'>
                            Menge
                        </th>
                        <th data-sortable='true' data-searchable='true'>
                            Teilaufmaß
                        </th>

                    </tr>
                    </thead>
                    <tbody
                        className='handwai-text-label-normal'>{aufmassTableBody}</tbody>
                </table>
                <br/>

                <Row>
                    <Col md={2}>
                        <Button
                            disabled={!isCsvDataAvailabe()}
                            className="handwai-btn-create" variant={"success"}>
                            <CSVLink
                                data={dataforcsv}
                                filename={moment().format("YYYYMMDD_")+"AUF_"+projectInformation.label}
                                onClick={() => {
                                    console.log("Downloading CSV"); // 👍🏻 Your click handling logic
                                }}
                            >CSV Export
                            </CSVLink>
                        </Button>


                    </Col>
                </Row>
                <br/> <br/>


            </div>
        </>);
}

export default memo(AufmasComponent);